export const LENDER_PAID_FEE = "1";
export const BORROWER_PAID_FEE = "2";

export default Object.freeze({
  [LENDER_PAID_FEE]: "Lender Paid Fee",
  [BORROWER_PAID_FEE]: "Borrower Paid Fee"
});
